import { css } from '@emotion/css';

import { Colors } from 'apps/shared/scripts/styles/constants';

export const activeButtonClassName = css({
  background: Colors.GrayHover,
});

export const menuClassName = css({
  marginTop: 32,
});
